import React, { useEffect, useState } from 'react'
import './prospect-view.scss'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import TakeAction from '../../components/user/sales-take-action/TakeAction'
import { accountingAxios } from '../../config/axios'
import { useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { convertIsoToAmPm, YYYYMMDDFormat } from '../../assets/javascript/formate-functions'
import { FaX, FaCheck } from 'react-icons/fa6'

const ProspectView = () => {
    const navigate = useNavigate()
    const { prospect_id } = useParams()
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState({})
    const [loading, setLoading] = useState('fetch')


    const handleModal = (status, title) => {
        setModal({
            status: true, title, content: <TakeAction actionStatus={status} setData={setData}
                setModal={setModal} />
        })
    }


    useEffect(() => {
        setLoading('fetch')
        accountingAxios.get(`/sales/bills/single/${prospect_id}`).then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            navigate('/')
            toast.error(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [])


    if (loading) {
        return <div>
            <h4>Loading...</h4>
        </div>
    }


    return (
        <div className="prospect-view-page-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Prospect view']}>
                <div className="border-div">
                    <div className="section-one-div">
                        <div className="prospect-item-details-comp-div">
                            {/* Personal data */}
                            <div className="prospect-section-div">
                                <div className="prospect-sub-title-div">
                                    <h3>Personal Details</h3>
                                </div>
                                <div className="section-list-div">
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Full name</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.first_name} {data?.last_name}</p>
                                        </div>
                                    </div>
                                    {data?.linked_cid && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Linked CID</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.linked_cid}</p>
                                        </div>
                                    </div>}
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Address, Place</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.address?.address}, {data?.address?.place}</p>
                                        </div>
                                    </div>
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>City, Pin code</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.address?.city}, {data?.address?.pin_code}</p>
                                        </div>
                                    </div>
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>State, Country</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.address?.state}, {data?.address?.country}</p>
                                        </div>
                                    </div>
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Primary number</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.primary_number?.country_code} {data?.primary_number?.number}</p>
                                        </div>
                                    </div>
                                    {data?.secondary_number?.number && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Secondary number</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.secondary_number?.country_code} {data?.secondary_number?.number}</p>
                                        </div>
                                    </div>}
                                    {data?.whatsapp_number?.number && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Whatsapp number</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.whatsapp_number?.country_code} {data?.whatsapp_number?.number}</p>
                                        </div>
                                    </div>}
                                    {data?.care_of?.asot_id && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Care of</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.care_of?.asot_id} | {data?.care_of?.full_name} | {data?.care_of?.asot_category}</p>
                                        </div>
                                    </div>}
                                    {data?.source_from?.asot_id && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Source from</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.source_from?.asot_id} | {data?.source_from?.full_name}</p>
                                        </div>
                                    </div>}
                                </div>
                            </div>

                            {/* prospect data */}
                            <div className="prospect-section-div">
                                <div className="prospect-sub-title-div">
                                    <h3>Prospect Data</h3>
                                </div>
                                <div className="section-list-div">
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Sales man</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{data?.sales_man}</p>
                                        </div>
                                    </div>

                                    {data?.i_schedule_date && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Scheduled date & time</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{new Date(data?.i_schedule_date).toDateString()}, {convertIsoToAmPm(new Date(data?.i_schedule_date))}</p>
                                        </div>
                                    </div>}

                                    {!data?.i_schedule_date && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Installation assign</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{new Date(data?.salesman_assign_i_date).toDateString()}</p>
                                        </div>
                                    </div>}

                                    {data?.confirmed_products?.map((cp) => {
                                        return <div className="list-item-div" key={cp?._id}>
                                            <div className="label-div">
                                                <p style={{ fontWeight: 'bold' }} >{cp?.p_type === 1 ? 'Purifier' : 'Vessel Filter'} ( CID: {cp?.allowed_cid?.join(', ')} )</p>
                                            </div>
                                            <div className="value-div" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', gap: '10px' }}>
                                                {cp?.p_type === 1
                                                    ? <p style={{ fontWeight: 'bold' }} >Use Same CID</p>
                                                    : <p style={{ fontWeight: 'bold' }} >{cp?.variant_list?.map((v) => `${v?.product_id}, `)}</p>}
                                            </div>
                                        </div>
                                    })}

                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Installation Status</p>
                                        </div>
                                        <div className="value-div" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', gap: '10px' }}>
                                            {data?.installation_status_text && <small className={`text-badge`}> {data?.installation_status_text}</small>}
                                            {data?.comment && <p>{data?.comment}</p>}
                                        </div>
                                    </div>

                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Bills Verification</p>
                                        </div>
                                        <div className="value-div" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', gap: '10px' }}>
                                            {data?.bills_status === 1
                                                ? <small className={`text-badge green-text`}><FaCheck /> OK</small>
                                                : data?.bills_status === 2
                                                    ? <small className={`text-badge red-text`}><FaX /> Not OK</small>
                                                    : <small className={`text-badge `}>Pending</small>}
                                            {data?.bills_status === 2 && <p>{data?.bills_comment}</p>}
                                        </div>
                                    </div>
                                    {data?.bills_action_date && <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Bills verified at</p>
                                        </div>
                                        <div className="value-div">
                                            <p>{new Date(data?.bills_action_date).toDateString()}</p>
                                        </div>
                                    </div>}
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Products Verification</p>
                                        </div>
                                        <div className="value-div" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', gap: '10px' }}>
                                            {data?.products_status === 1
                                                ? <small className={`text-badge green-text`}><FaCheck /> OK</small>
                                                : data?.products_status === 2
                                                    ? <small className={`text-badge red-text`}><FaX /> Not OK</small>
                                                    : <small className={`text-badge `}>Pending</small>}
                                            {data?.products_status === 2 && <p>{data?.products_comment}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Bill Data */}
                            <div className="prospect-section-div">
                                <div className="prospect-sub-title-div">
                                    <h3>Bill Info</h3>
                                </div>
                                <div className="section-list-div">
                                    <div className="list-item-div" >
                                        <div className="label-div">
                                            <p style={{ color: "blue", fontWeight: "700" }}>Total Receivable amount</p>
                                        </div>
                                        <div className="value-div">
                                            <p style={{ color: "blue", fontWeight: "800" }}>₹ {(data?.total_receivable_amount || 0).toFixed(2) || 0}</p>
                                        </div>
                                    </div>
                                    <div className="list-item-div">
                                        <div className="label-div">
                                            <p>Advance amount</p>
                                        </div>
                                        <div className="value-div">
                                            <p>₹ {(data?.advance_amount?.amount || 0).toFixed(2) || 0}</p>
                                        </div>
                                    </div>
                                    {data?.balance_payment_methods?.map((m, idx) => {
                                        return <div className="list-item-div">
                                            <div className="label-div">
                                                <p>Period {idx + 1} ({YYYYMMDDFormat(new Date(m?.date))})</p>
                                            </div>
                                            <div className="value-div">
                                                <p>₹ {(m?.amount || 0).toFixed(2) || 0}</p>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>

                            {/* payment details */}
                            <div className="prospect-section-div">
                                <div className="prospect-sub-title-div">
                                    <h3>Payment Info</h3>
                                </div>
                                <div className="section-list-div">
                                    {data?.payment_history?.map((m, idx) => {
                                        return <div className="list-item-div" style={{ gridTemplateColumns: "1fr 1fr 1fr" }}>
                                            <div className="label-div">
                                                <p>{YYYYMMDDFormat(new Date(m?.date))}</p>
                                            </div>
                                            <div className="value-div">
                                                <p>₹ {(m?.total_amount || 0).toFixed(2) || 0} ({m?.method})</p>
                                            </div>
                                            <div className="value-div">
                                                <p>{m?.confirm ? 'OK' : m?.rejected ? 'Rejected' : ""}</p>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section-two-div">
                        <div className="buttons-div">
                            {![1, 2].includes(data.bills_status) && <>
                                <button className='green' onClick={() => handleModal(1, 'Accept request')}>Accept</button>
                                <button className='red' onClick={() => handleModal(2, 'Reject request')}>Reject</button>
                            </>}

                            {data.bills_status === 2 && <>
                                <button className='green' onClick={() => handleModal(1, 'Accept request')}>Return to Accept</button>
                            </>}

                            <button onClick={() => window.open(`https://salesv1.allinacedev.in/controller/prospect/e-form/${data?.accepted_e_form_id}`, '_blank')}>
                                View Quotation
                            </button>

                        </div>
                    </div>
                </div>
            </SinglePage>
        </div>
    )
}

export default ProspectView